'use strict'

import React from 'react'
import TemplateSettings from './views/TemplateSettings'
import * as templateDisplayApi from './api/templateDisplayApi';
import * as userApi from './api/userApi';
import '../css/app.css'

class App extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            moduleId: parseInt(document.getElementById('hdnStencilDisplaySettingsModuleId').value),
            tabId: parseInt(document.getElementById('hdnStencilDisplaySettingsTabId').value),
            templateData: null,
            isLoading: true,
            isAdmin: false
        }

        this.setTemplateData = this.setTemplateData.bind(this);
    }

    async setTemplateData() {
        const [templateData, isAdmin] = await Promise.all(
            [
                templateDisplayApi.loadTemplateData(this.state.moduleId),
                userApi.isSuperUser()
            ]
        );

        this.setState({
            templateData,
            isAdmin,
            isLoading: false
        });
    }

    componentDidMount() {
        this.setTemplateData();
    }

    render() {
        const { isLoading, moduleId, tabId, templateData, isAdmin } = this.state;

        return (
            !isLoading && <TemplateSettings moduleId={moduleId} tabId={tabId} templateData={templateData} isAdmin={isAdmin} />
        );
    }
}

module.exports = App
